import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

interface IWithdrawBalanceState {
  withdrawBalance: number;
}

const initialState: IWithdrawBalanceState = {
  withdrawBalance: 0,
};

const WithdrawBalanceSlice = createSlice({
  name: "withdrawBalance",
  initialState,
  reducers: {
    setWithdrawBalance: (state, action: PayloadAction<number>) => {
      state.withdrawBalance = action.payload;
    },
  },
});

export const { setWithdrawBalance } = WithdrawBalanceSlice.actions;

export default WithdrawBalanceSlice.reducer;
